import { useEffect, useRef, useState } from "react";
import { useProcessSteps } from "@/hooks/useSiteContent";
import ContentStatus from "@/components/feature/ContentStatus";

export default function ProcessSection() {
  const { data: steps, loading, error, reload } = useProcessSteps();
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-accent-100 text-accent-700 text-xs md:text-sm font-label font-medium rounded-full mb-4">
            <i className="ri-road-map-line" />
            Quy trình
          </span>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Trải nghiệm chỉ với 4 bước đơn giản
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto font-body">
            Từ lúc chọn dịch vụ đến khi cảm nhận kết quả, mọi thứ đều dễ dàng và nhanh chóng.
          </p>
        </div>

        <ContentStatus loading={loading} error={error} onRetry={reload}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`relative bg-background-50 border border-background-200/70 rounded-lg p-6 transition-all duration-700 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{
                transitionDelay: visible ? `${index * 100}ms` : "0ms",
              }}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className={`${step.icon} text-xl`} />
                </div>
                <span className="font-display text-4xl font-bold text-background-200 leading-none">
                  {String(step.id).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-display text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed font-body">
                {step.description}
              </p>
            </div>
          ))}
        </div>
        </ContentStatus>
      </div>
    </section>
  );
}